(function () {
    'use strict';

    var controller = function ($element, $timeout) {
        var ctrl = this;
        var _init = false;

        var map = null;
        var marker = null;
        var circle = null;

        var defaultLatLng = {
            lat: 52.184430,
            lng: -2.157050,
            label: 'Andrew Grant Head Office'
        };

        ctrl.latLng = {};

        //Built in methods (aliased below for minifcation).
        ctrl.$onInit = init;
        ctrl.$onChanges = change;
        ctrl.$onDestroy = destroy;

        //-
        function destroy() {
            marker.removeEventListener('drag', startDrag);
            marker.removeEventListener('dragend', endDrag);

            marker = null;
            map = null;
        }

        // Case numbers based upon the value of ctrl.radius passed to component.
        ctrl.calcViewVal = function (radius) {
            switch (radius) {
                case 805: case 1609: {
                    return 14;
                }
                case 3219: {
                    return 13;
                }
                case 8047: {
                    return 12;
                }
                case 16093: {
                    return 10;
                }
                case 24140: {
                    return 10;
                }
                case 32187: {
                    return 9;
                }
                default: {
                    return 12;
                }
            }
        };

        function change(changes) {
            if (_init) {
                //console.log('changes', changes);
                
                var useDefault = ctrl.lat === null && ctrl.lng === null;
                var viewVal = ctrl.calcViewVal(ctrl.radius);

                if ((changes.lat || changes.lng) && !!map) {

                    ctrl.latLng = {
                        lat: useDefault ? defaultLatLng.lat : ctrl.lat,
                        lng: useDefault ? defaultLatLng.lng : ctrl.lng
                    };

                    map.setView({ lon: ctrl.latLng.lng, lat: ctrl.latLng.lat }, viewVal); 

                    marker.setLatLng([ctrl.latLng.lat, ctrl.latLng.lng]);
                    if (!!circle) circle.setLatLng([ctrl.latLng.lat, ctrl.latLng.lng]);
                }
                if (changes.radius) {
                    if (!!circle) circle.remove();
                    if (!!changes.radius.currentValue)
                        circle = L.circle([ctrl.latLng.lat, ctrl.latLng.lng], { radius: ctrl.radius })
                            .addTo(map);
                    map.setView({ lon: ctrl.latLng.lng, lat: ctrl.latLng.lat }, viewVal);
                }
                if (changes.label && changes.label.currentValue)
                    marker.bindPopup(useDefault ? defaultLatLng.label : ctrl.label);
            }
        }

        function startDrag() {
            markerPosition();
        }

        function endDrag() {
            markerPosition(true);
        }

        function markerPosition(drop) {
            ctrl.latLng = marker.getLatLng();
            if (!!drop) {
                if (typeof ctrl.onMarkerDrop === 'function')
                    ctrl.onMarkerDrop({ $event: { lat: ctrl.latLng.lat, lng: ctrl.latLng.lng } });
            } else {
                if (typeof ctrl.onMarkerDrag === 'function')
                    ctrl.onMarkerDrag({ $event: { lat: ctrl.latLng.lat, lng: ctrl.latLng.lng } });
            }
            if (!!circle) circle.setLatLng([ctrl.latLng.lat, ctrl.latLng.lng]);
        }

        function init() {
            ctrl.latLng = {
                lat: ctrl.lat || defaultLatLng.lat,
                lng: ctrl.lng || defaultLatLng.lng
            }
            ctrl.label = ctrl.label || defaultLatLng.label;

            $timeout(function () {
                // initialize Leaflet
                map = L.map($element.children('.map-container')[0], {
                    center: [ctrl.latLng.lat, ctrl.latLng.lng],
                    zoom: ctrl.calcViewVal(ctrl.radius), // 12 before
                    dragging: !ctrl.staticMap,
                    scrollWheelZoom: !ctrl.staticMap,
                    touchZoom: !ctrl.staticMap,
                });

                // add the OpenStreetMap tiles
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19, // 19
                    attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
                }).addTo(map);

                // show the scale bar on the lower left corner
                L.control.scale().addTo(map);

                // show a marker on the map
                marker = L.marker(
                    [ctrl.latLng.lat, ctrl.latLng.lng],
                    {
                        draggable: (typeof ctrl.onMarkerDrag === 'function') ||
                            (typeof ctrl.onMarkerDrop === 'function'),
                        autoPan: true
                    });
                marker.bindPopup(ctrl.label);
                marker.addTo(map);

                if (!!ctrl.radius)
                    circle = L.circle([ctrl.latLng.lat, ctrl.latLng.lng], { radius: ctrl.radius })
                        .addTo(map);

                marker.addEventListener('drag', startDrag);
                marker.addEventListener('dragend', endDrag);
            });

            _init = true;
        }
    };

    app.component('openmap', {
        restrict: 'E',
        bindings: {
            lat: '<?',
            lng: '<?',
            label: '<?',
            radius: '<?',

            staticMap: '<?',

            onMarkerDrag: '&?',
            onMarkerDrop: '&?'
        },
        controller: ['$element', '$timeout', controller],
        template: '<div class="map-container"></div>'
    });
})();